/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from 'react';
// BASE components
import useThemeMediaQuery from "../../../../@BASE/hooks/useThemeMediaQuery";
// Material-UI components
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Typography from '@mui/material/Typography';

export default function StatusStepper(props) {
  const { steps, activeStep } = props;
  const currentStep = steps[activeStep].index || 0;

  return (
    <Stepper activeStep={currentStep} orientation="vertical">
      {Object.keys(steps).map((key) => (    
        <Step key={steps[key].index}>
          <StepLabel>{steps[key].label}</StepLabel>
        </Step>
      ))}
    </Stepper>
  );
}